import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/data/lakaData";

const Treatments = () => {
  const goTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="tratamientos"
      data-testid="treatments-section"
      className="py-24 md:py-32"
      style={{ background: "#E8DFD1" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="laka-eyebrow">Tratamientos</span>
            <h2 className="mt-4 font-serif-laka text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08] text-[#1A1A1A]">
              Un catálogo pensado <span className="italic text-[#D6B36A]">para cada piel</span>
            </h2>
          </div>
          <p className="text-sm text-[#1A1A1A]/70 max-w-md leading-relaxed font-light">
            Seis universos beauty diseñados para ofrecer una respuesta personalizada
            a cada necesidad. Explora la categoría que mejor encaje contigo.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CATEGORIES.map((cat) => (
            <article
              key={cat.key}
              data-testid={`treatment-card-${cat.key}`}
              className="group relative bg-[#FBF6F2] laka-card overflow-hidden"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.label}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 bg-[#FBF6F2]/95 px-3 py-1 text-[0.6rem] tracking-[0.28em] uppercase text-[#D6B36A] font-medium">
                  {cat.tag}
                </div>
              </div>
              <div className="p-7">
                <h3 className="font-serif-laka text-2xl text-[#1A1A1A] leading-tight">
                  {cat.label}
                </h3>
                <p className="mt-3 text-sm text-[#1A1A1A]/70 leading-relaxed font-light">
                  {cat.text}
                </p>
                <button
                  data-testid={`treatment-card-cta-${cat.key}`}
                  onClick={() => goTo("precios")}
                  className="mt-6 inline-flex items-center gap-2 text-[0.72rem] tracking-[0.22em] uppercase font-medium text-[#1A1A1A] group-hover:text-[#D6B36A] transition-colors"
                >
                  Ver detalle
                  <ArrowUpRight
                    className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    strokeWidth={1.5}
                  />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Treatments;
